import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageReportAction } from '../coverageReport.action';

type IDependencies = ICoverageApiDependencySegment;

export const updateCoverageReportEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageReportAction.update.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return coverageApi.updateCoverageReport(payload.reportId, { name: payload.name }).pipe(
      mergeMap(() => {
        resolve(payload.reportId);
        return [CoverageReportAction.update.done({ params })];
      }),
      catchApiError((error) => [
        CoverageReportAction.update.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
